export default "__VITE_ASSET__5mLIPmEG__"